import * as stylex from '@stylexjs/stylex';
import * as featureIcons from './svg/feature-icons';
import { iconsStyles } from './svg/styles';
export interface FramedFeatureIconProps {
  icon: keyof typeof featureIcons;
}
export function FramedFeatureIcon({
  icon
}: FramedFeatureIconProps) {
  const Icon = featureIcons[icon];
  return <div {...stylex.props([iconsStyles.iconFrame])}>
      <Icon />
    </div>;
}